module.exports = __webpack_public_path__ + "img/20200912_130756.aad1ce49.jpg";